import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {SalesPersonDetailsInterface} from '../../../interfaces/session/sales-person-details.interface';
import {ModalService} from '../../../services/modal/modal.service';
import {SnackbarService} from '../../../services/snackbar/snackbar.service';
import {MailsService} from '../../../services/mails/mails.service';
import {ProductAnnouncement} from '../../../config/feature-presentations';
import {ColorType} from '../../parts/fe-icon/fe-icon.component';

/**
 * Modale de présentation d'une nouveauté produit (deux colonnes), avec demande de contact au chargé d'affaires.
 */
@Component({
  selector: 'app-fe-announcement-modal',
  templateUrl: './fe-announcement-modal.component.html',
  styleUrls: ['./fe-announcement-modal.component.scss']
})
export class FeAnnouncementModalComponent {

  protected announcement: ProductAnnouncement;
  protected text: string = '';
  protected salesPersonDetails: SalesPersonDetailsInterface = {};
  protected readonly ColorType = ColorType;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              private modalService: ModalService,
              private snackbarService: SnackbarService,
              private mailService: MailsService) {
    this.announcement = data.announcement;
    this.text = data.text;
    if (data.salesPersonDetails != null) {
      this.salesPersonDetails = data.salesPersonDetails;
    }
  }

  protected getCommercialName(): string {
    const parts: string[] = [];
    if (this.salesPersonDetails.salesPersonFirstname != null) {
      parts.push(this.salesPersonDetails.salesPersonFirstname.trim());
    }
    if (this.salesPersonDetails.salesPersonName != null) {
      parts.push(this.salesPersonDetails.salesPersonName);
    }
    return parts.join(' ');
  }

  protected askForContact(): void {
    this.modalService.textAreaModal('Demande de contact', 'Une demande de contact va être envoyée à ' +
        'votre commercial dédié.<br>' + 'Voulez-vous continuer ?', args => {
      this.mailService.contactSalespersonn(this.announcement.feature, args).subscribe(() => {
        this.snackbarService.showSuccessSnackbar('Demande de contact envoyé',
            'Votre commercial dédié vous recontactera sous 48h.');
      });
    }, 'Vous pouvez ajouter un commentaire à votre demande.');
  }
}
